export function converterMoedaParaNumeroInteiro(value: string): number {
    // Remove o símbolo de moeda e espaços
    let numericValue = value.replace(/[^\d,-]/g, '');


    // Substitui a vírgula por ponto para conversão decimal
    numericValue = numericValue.replace(',', '.');

    // Converte para número
    const result = parseFloat(numericValue);

    return isNaN(result) ? 0 : result; // Retorna 0 se a conversão falhar
}